export default "__VITE_ASSET__D43_re6W__"